



















import {
  defineComponent, computed, reactive, watch, ref,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import VueTagsInput from '@johmun/vue-tags-input';

import searchCreatorsQuery from '@/gql/searchCreators.gql';

const CommonMultiCreatorsSelector = defineComponent({
  setup(props: any, context: any) {
    const name = ref('');
    const tags = computed(() => props.value.map((t: string) => ({ text: t }))); // convert to lib's format

    const { result: creatorsResult } = useQuery(searchCreatorsQuery, computed(() => ({
      searchFirstName: `%${name.value}%`,
    })));
    const searchedCreator = useResult(creatorsResult, [], (data) => {
      const parsedCreator = data.creators.data.map((t: { firstName: string; lastName: string; id: number }) => ({ text: `${t.firstName} ${t.lastName} value: ${t.id}` })); // convert to lib's format
      return parsedCreator;
    });

    function onCreatorsUpdate(newTags: { text: string }[]) {
      context.emit('input', newTags.map((objTag) => objTag.text)); // convert back to our format
    }

    function performAdd(item: any) {
      const _value = [...props.value, item];
      context.emit('input', _value);
      name.value = '';
    }

    return {
      name,
      tags,
      onCreatorsUpdate,
      searchedCreator,
      performAdd,
    };
  },
  props: {
    value: {
      type: Array,
      default() { return []; },
    },
    label: {
      type: String,
      default() { return 'ผู้สร้าง'; },
    },
    maxTags: {
      type: Number,
      default() { return null; },
    },
  },
  components: {
    VueTagsInput,
  },
});

export default CommonMultiCreatorsSelector;
